// 画面ごとのヘルプの中身。手引き（BuilderGuideBook）と同じ作りで、
// その画面のキャプチャの「どこを見るか」を丸で囲んだり拡大したりして見せる。
// 文章だけのヘルプは読まれないので使わない。
//
// focus は実画面を getBoundingClientRect で実測した値（ビューポート 1280x800 に対する比率）。
// キャプチャの撮り直しは scripts/capture-guide.mjs。

import {
  GuideRect,
  GuideBookPage,
  GuideFocusMode,
  GuideBookChapter,
} from "features/builder/elements/BuilderGuideBook";

const KEY = "MSG_BUILDER_HELP";

const page = (
  capture: string,
  key: string,
  mode: GuideFocusMode,
  focus?: GuideRect,
): GuideBookPage => ({
  key: `${capture}_${key}`,
  capture,
  mode,
  focus,
  titleKey: `${KEY}_${key.toUpperCase()}_TITLE`,
  descKey: `${KEY}_${key.toUpperCase()}_DESC`,
});

const zoom = (capture: string, key: string, focus: GuideRect) =>
  page(capture, key, GuideFocusMode.ZOOM, focus);

const chapter = (key: string, icon: string, pages: GuideBookPage[]): GuideBookChapter[] => [
  { key, icon, labelKey: `${KEY}_${key.toUpperCase()}_TITLE`, pages },
];

/** くわしく（ピースじょうほう） */
export const HELP_DETAIL = chapter("detail", "info", [
  zoom("info", "detail_tabs", { x: 0.421, y: 0.328, w: 0.404, h: 0.067 }),
  zoom("info", "detail_name", { x: 0.431, y: 0.411, w: 0.383, h: 0.085 }),
  zoom("info", "detail_cover", { x: 0.174, y: 0.62, w: 0.234, h: 0.117 }),
]);

/** AIで マップを つくる */
export const HELP_AI = chapter("ai", "smart_toy", [
  zoom("ai", "ai_level", { x: 0.199, y: 0.324, w: 0.264, h: 0.136 }),
  zoom("ai", "ai_floor", { x: 0.199, y: 0.477, w: 0.264, h: 0.126 }),
  zoom("ai", "ai_create", { x: 0.189, y: 0.651, w: 0.285, h: 0.11 }),
]);

/** ブロックを えらぼう */
export const HELP_ASSET = chapter("asset", "category", [
  zoom("assets", "asset_all", { x: 0.214, y: 0.216, w: 0.573, h: 0.569 }),
  zoom("assets", "asset_kind", { x: 0.227, y: 0.305, w: 0.547, h: 0.125 }),
  zoom("assets", "asset_pick", { x: 0.237, y: 0.43, w: 0.526, h: 0.221 }),
]);

/** りれきの かくにん */
export const HELP_HISTORY = chapter("history", "history", [
  zoom("history", "history_all", { x: 0.266, y: 0.193, w: 0.469, h: 0.615 }),
  zoom("history", "history_item", { x: 0.286, y: 0.384, w: 0.424, h: 0.097 }),
  zoom("history", "history_undo", { x: 0.613, y: 0.405, w: 0.089, h: 0.054 }),
]);

/** かんせいの じゅんび（左パネル） */
export const HELP_PUBLISH = chapter("publish", "rocket_launch", [
  zoom("main", "publish_steps", { x: 0.005, y: 0.158, w: 0.375, h: 0.624 }),
  // キャラクターとゴールは じめんの上にしか置けない。詰まりやすいので先に伝える
  zoom("main", "publish_ground", { x: 0.241, y: 0.888, w: 0.427, h: 0.104 }),
  zoom("main", "publish_check", { x: 0.016, y: 0.269, w: 0.354, h: 0.077 }),
  zoom("main", "publish_go", { x: 0.005, y: 0.701, w: 0.375, h: 0.081 }),
]);
